import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'uui-skeleton',
  styleUrl: 'uui-skeleton.css',
  shadow: true
})
export class UuiSkeleton {
  /**
   * Default number of skeleton items to display
   */
  @Prop() count: number = 1;

  render() {
    const skeletonItems = [];
    for (let i = 0; i < this.count; i++) {
      skeletonItems.push(<div class="loader-item"></div>);
    }

    return <div class="loader-container">{skeletonItems}</div>;
  }
}
